module.exports = __webpack_public_path__ + "static/media/shopping-cart.8a021cce.svg";